<template>
  <div class="m-0 p-5 text-white bg-dark" style="min-height: 500px;">
    <b-input-group prepend="SERIAL" class="mb-2">
      <b-input v-model="serialPrefix1"/>-
      <b-input v-model="serialPrefix2"/>-
      <b-input v-model="serialPrefix3"/>-
      <b-input v-model="serialPrefix4"/>XXX
    </b-input-group>
    <b-input-group prepend="JSON" class="mb-2" style="height: 200px;">
      <b-textarea v-model="serialList" class="mb-2"></b-textarea>
    </b-input-group>
    <b-input-group prepend="CSV" class="mb-2" style="height: 200px;">
      <b-textarea v-model="serialCSV" class="mb-2"></b-textarea>
    </b-input-group>
    <b-input-group class="mb-2">
      <b-button @click="createSerial" style="margin-right: 20px;">json 생성</b-button>
      <b-button @click="serialJSON2CSV" style="margin-right: 20px;">json2csv</b-button>
      <b-button @click="serialCSV2JSON" style="margin-right: 20px;">csv2json</b-button>
      <b-button @click="uploadSerial" style="margin-right: 20px;">json 업로드</b-button>
    </b-input-group>
  </div>
</template>
<script>
import { mapState } from "vuex"
import { mapSetter } from "@/plugins/vuexUtils.js"
import uiUtil from "@/mixins/util.js"

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

import { db } from "@/plugins/firebase.js"

export default {
  name: "tAdmin",
  mixins: [uiUtil],
  data: function() {
    return {
      serialList: "",
      serialCSV: "",
      serialPrefix1: "TINK",
      serialPrefix2: "ABLE",
      serialPrefix3: "XPUB",
      serialPrefix4: "A",
    }
  },
  methods: {
    serialCSV2JSON: function() {
      var serialList = []
      var splited = this.serialCSV.split("\n")
      for(var i=0;i<splited.length;i++) {
        if(splited[i] != "") {
          var temp = splited[i].split(",")
          var serial = {}
          serial.serial = temp[0]
          serial.code = temp[1]
          if(temp.length >= 3 && temp[2] != "") serial.mac = temp[2]
          if(temp.length >= 4 && temp[3] != "") serial.admin = temp[3]
          serialList.push(serial)
        }
      }
      this.serialList = JSON.stringify(serialList, null, "\t")
    },
    serialJSON2CSV: function() {
      var str = ""
      var serialList = JSON.parse(this.serialList.replace("\t", "").replace("\n", ""))
      for(var i=0;i<serialList.length;i++) {
        if(typeof(serialList[i].serial) != "undefined") {
          str += serialList[i].serial
          str += ","
        }
        else {
          str += ","
        }
        if(typeof(serialList[i].code) != "undefined") {
          str += serialList[i].code
          str += ","
        }
        else {
          str += ","
        }
        if(typeof(serialList[i].mac) != "undefined") {
          str += serialList[i].mac
          str += ","
        }
        else {
          str += ","
        }
        if(typeof(serialList[i].admin) != "undefined") {
          str += serialList[i].admin
          str += "\n"
        }
        else {
          str += "\n"
        }
      }
      this.serialCSV = str;
    },
    createSerial: function() {
      var serialList = []
      var alphas = "ABCDEFGHJKMNPRSTWXYZ"
      var serialPrefixBase = this.serialPrefix1 + "-" + this.serialPrefix2 + "-" + this.serialPrefix3 + "-" + this.serialPrefix4

      for(var i=0;i<20;i++) {
        var serialCode1 = serialPrefixBase + alphas.charAt(i)
        for(var j=0;j<20;j++) {
          var serialCode2 = serialCode1 + alphas.charAt(j)
          for(var k=0;k<20;k++) {
            var serialCode3 = serialCode2 + alphas.charAt(k)

            var mid = (i*20*20+j*20+k) + "";

            if(mid.length==1) mid = "000" + mid;
            else if(mid.length==2) mid = "00" + mid;
            else if(mid.length==3) mid = "0" + mid;

            var accessCode =
            Math.floor(Math.random()*10) + "" + Math.floor(Math.random()*10) + "" + Math.floor(Math.random()*10) + "" + Math.floor(Math.random()*10) + "-" + mid + "-" + Math.floor(Math.random()*10) + "" +  Math.floor(Math.random()*10) + "" +  Math.floor(Math.random()*10) + "" +  Math.floor(Math.random()*10) + "-" +  Math.floor(Math.random()*10) + "" +  Math.floor(Math.random()*10) + "" +  Math.floor(Math.random()*10) + "" +  Math.floor(Math.random()*10)
            var serial = {}
            serial.serial = serialCode3
            serial.code = accessCode
            serialList.push(serial)
          }
        }
      }
      this.serialList = JSON.stringify(serialList, null, "\t")
    },
    uploadSerial: function() {
      var serialList = JSON.parse(this.serialList.replace("\t", "").replace("\n", ""))
      if(serialList instanceof Array) {
        var batch = db.batch()
        serialList.forEach(serial => {
          var item = db.collection("serials").doc(serial.serial)
          let newItem = {}
          newItem.code = serial.code
          if(typeof(serial.mac) != "undefined" && serial.mac != "") {
            newItem.mac = serial.mac
          }
          if(typeof(serial.admin) != "undefined" && serial.admin != "") {
            newItem.admin = serial.admin
          }
          batch.set(item, newItem, { merge: true })
        })
        batch.commit()
        .then(() => {
          window.alert("시리얼 생성에 성공했습니다.")
        })
        .catch((error) => {
          window.alert("에러가 발생했습니다. 에러내용: "+ error)
        })
      }
      else {
        window.alert("형식이 잘못되었습니다.")
      }
    },

  },
  computed: {
    ...mapSetter(
      mapState({
        loginUser: state => state.loginUser,
        currentUser: state => state.currentUser,
        presentationMode:  state => state.presentationMode,
      })
    )
  },
}
</script>
